import { useEffect, useState } from "react";
import "../assets/css/lineUps.css";
import { Loading } from "../components/loading";
import { NijisanjiSocial } from "../constants/nijisanjiSocial";

export const LineUps = ({
  lineUps,
  isShowSectionTitle = true,
  logo,
  cafeLogo,
  licensorLabel,
}) => {
  const [lineUpGroup, setLineUpGroup] = useState([]);
  const [loading, setLoading] = useState(true);
  const groupFilesByPrefix = (urls) => {
    const groups = {};
    urls.forEach((url) => {
      const parts = decodeURIComponent(url).split("/");
      const fileName = parts[parts.length - 1].split("?")[0];
      const fileNameOnly = fileName.split(".")[0];
      const prefix = fileNameOnly.split("_")[0];
      if (!groups[prefix]) {
        groups[prefix] = [];
        groups[prefix].push(NijisanjiSocial.getNijisanjiSocialValue(prefix));
      }
      groups[prefix].push(url);
    });
    return Object.values(groups);
  };
  const sortLineUpGroup = (lineUpGroup) => {
    const orderKeys = NijisanjiSocial.NijisanjiSocialList.map(
      (item) => item.value
    );
    return lineUpGroup.sort((a, b) => {
      const aIndex = orderKeys.indexOf(a[0]);
      const bIndex = orderKeys.indexOf(b[0]);
      return aIndex - bIndex;
    });
  };
  useEffect(() => {
    if (lineUps && lineUps.length > 0 && (logo || cafeLogo)) {
      const groupedLineUps = groupFilesByPrefix(lineUps);
      setLineUpGroup(sortLineUpGroup(groupedLineUps));
      setLoading(false);
    }
  }, [lineUps, isShowSectionTitle, logo, cafeLogo]);

  return (
    <section id="lineUps">
      {loading ? (
        <Loading />
      ) : (
        <div className="line-up-container">
          {isShowSectionTitle && (
            <div>
              <h3>LINE UPS</h3>
              <hr />
            </div>
          )}
          <div className="line-ups-image-wrapper">
            {lineUpGroup.map((lineUp, index) => (
              <div key={index} className="line-ups-image">
                {lineUp.map((item, i) =>
                  i === 0 ? null : item.includes("text") ? (
                    <a
                      href={lineUp[0]}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={i}
                      className="vtuber-text-link"
                    >
                      <img src={item} alt={item} className="vtuber-text" />
                    </a>
                  ) : (
                    <img
                      key={i}
                      src={item}
                      alt={item}
                      className={
                        item.includes("back") ? "vtuber-back" : "vtuber-front"
                      }
                    />
                  )
                )}
              </div>
            ))}
          </div>
          <div className="logo-container">
            <img src={cafeLogo} className="cafe-image" alt="Cafe" />
            <label className="collab-x">x</label>
            <img src={logo} className="logo-image" alt="Logo" />
          </div>
          <label className="licensor-label">{licensorLabel}</label>
        </div>
      )}
    </section>
  );
};
